import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {CreateEditSCOTModal} from '@ey/canvascoreservices';
import {useDispatch, useSelector} from 'react-redux';
import {currentResource} from '../../../util/utils';
import {getAllItApplications} from '../../../actions/ITApplication/itapplicationaction';
import {cleanScot, createSCOT, getScotById, updateScot} from '../../../actions/scots/scotsactions';
import Utility from '../../../util/utilityfunctions';
//import CreateEditSCOTModal from './CreateEditSCOTModal/src';
import {setIsModalOpen} from '../../../actions/setismodalopen';
import {clearErrors} from '../../../actions/erroractions';
import ErrorSummary from '../ErrorSummary/ErrorSummary';

export default function CreateEditSCOTModalWrapper(props) {
	const {isCreate, isEdit, showModal, setShowModal, entityId, onClose, onSave, viewOnly = false} = props;

	const [engagementId] = useSelector((state) => [state.engagementId]);
	const itApplications = useSelector((state) => {
		return {data: Object.values(state.bodiesSpecial?.itApplications.byId)};
	});
	const scotDetails = useSelector((state) => state.scotsDetails);
	const dispatch = useDispatch();

	useEffect(() => {
		if (showModal) {
			dispatch(setIsModalOpen(true));
		} else {
			dispatch(setIsModalOpen(false));
		}
	}, [showModal]);

	return (
		<>
			{isCreate && (
				<CreateEditSCOTModal
					showModal={showModal}
					setShowModal={setShowModal}
					engagementId={engagementId}
					labels={currentResource.CreateEditSCOTLabels}
					itApplications={itApplications}
					createScotAction={(data) => dispatch(createSCOT(engagementId, data, {isManageScots: true}))}
					getAllITApplicationAction={() =>
						getAllItApplications(engagementId, undefined, {
							includeControl: true,
							includeScot: true,
							includePagination: false
						})
					}
					onClose={onClose}
					theme={Utility.getTheme()}
					errorComponent={<ErrorSummary />}
				/>
			)}
			{isEdit && (
				<CreateEditSCOTModal
					showModal={showModal}
					setShowModal={setShowModal}
					engagementId={engagementId}
					labels={currentResource.CreateEditSCOTLabels}
					scotId={entityId}
					itApplications={itApplications}
					editScotAction={(data) => dispatch(updateScot(engagementId, entityId, data, {isManageScots: true}))}
					getAllITApplicationAction={() =>
						getAllItApplications(engagementId, undefined, {
							includeControl: true,
							includeScot: true,
							includePagination: false
						})
					}
					getSCOTById={() => getScotById(engagementId, entityId, {includeIT: true, includeControl: true}, true)}
					scotDetails={scotDetails}
					onClose={() => {
						dispatch(cleanScot());
						dispatch(clearErrors());
						onClose && onClose();
					}}
					viewOnly={viewOnly}
					theme={Utility.getTheme()}
					onSave={onSave}
					errorComponent={<ErrorSummary />}
				/>
			)}
		</>
	);
}

CreateEditSCOTModalWrapper.propTypes = {
	isCreate: PropTypes.bool,
	isEdit: PropTypes.bool,
	showModal: PropTypes.bool.isRequired,
	setShowModal: PropTypes.func.isRequired,
	entityId: PropTypes.number,
	onClose: PropTypes.func
};
